module.exports = __webpack_public_path__ + "static/logo-f0a375404190047b7c009f012e293dbf.svg";